export type PaymentMethodModel = {
  id: number,
  processing_api?: string,
  short_name?: string,
  title: string,
  data?: any,
}

export type PaymentMethodRequestOptions = {}

const state = {
  id: null,
  processing_api: '',
  short_name: '',
  title: '',
}

export const requiredFields = [
  { key: 'short_name' },
  { key: 'title' },
]

export default state
